
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { VfbElement, VfbElementType } from './Element';
import Chevron from './Chevron';
import ElementFileExtra from './ElementFileExtra';
import ElementStaticExtra from './ElementStaticExtra';
import ElementDateExtra from './ElementDateExtra';
import ElementTextExtra from './ElementTextExtra.vue';

@Component({
  components: {
    Chevron,
    ElementDateExtra,
    ElementFileExtra,
    ElementListExtra: () => import('./ElementListExtra.vue'), //circular import
    ElementObjectExtra: () => import('./ElementObjectExtra.vue'), //circular import
    ElementStaticExtra,
    ElementTextExtra,
  },
})
export default class ElementGeneral extends Vue {
  @Prop({ required: true })
  builderElement!: VfbElement;
  @Prop({ required: true })
  collapsed!: boolean;

  get showGeneral(): boolean {
    return this.builderElement.type !== 'object';
  }

  get displayFormat(): string {
    return this.builderElement.displayFormat ?? '';
  }

  set displayFormat(value: string) {
    if (typeof this.builderElement.displayFormat === 'undefined') {
      this.$set(this.builderElement, 'displayFormat', value); // if property didn't exist, it needs to be set this way, so vue makes it reactive
    }
    this.builderElement.displayFormat = value;
  }

  get info(): string {
    return this.builderElement.info ?? '';
  }

  set info(value: string) {
    if (typeof this.builderElement.info === 'undefined') {
      this.$set(this.builderElement, 'info', value); // if property didn't exist, it needs to be set this way, so vue makes it reactive
    }
    this.builderElement.info = value;
  }

  get label(): string {
    return this.builderElement.label ?? '';
  }

  set label(value: string) {
    if (typeof this.builderElement.label === 'undefined') {
      this.$set(this.builderElement, 'label', value); // if property didn't exist, it needs to be set this way, so vue makes it reactive
    }
    this.builderElement.label = value;
  }

  get placeholder(): string {
    return this.builderElement.placeholder ?? '';
  }

  set placeholder(value: string) {
    if (typeof this.builderElement.placeholder === 'undefined') {
      this.$set(this.builderElement, 'placeholder', value); // if property didn't exist, it needs to be set this way, so vue makes it reactive
    }
    this.builderElement.placeholder = value;
  }

  get name(): string {
    return this.builderElement.name ?? '';
  }

  get type(): VfbElementType | 'unknown' {
    return this.builderElement.type ?? 'unknown';
  }
}
